import { Body1, Button } from '@cian/ui-kit';
import * as React from 'react';

import { COMPARE_FLIGHT_ONBOARDING_BUTTON_TEXT } from './constants';
import * as styles from './NewbuildingHeaderCompareButton.css';

interface ICompareFlightOnboardingContentProps {
  onButtonClick(): void;
}

export function CompareFlightOnboardingContent({ onButtonClick }: ICompareFlightOnboardingContentProps) {
  return (
    <div className={styles['onboarding-content']} data-testid="NewbuildingCompareFlightOnboarding">
      <div className={styles['onboarding-flight-content']}>
        <Body1 color="text-inverted-default">
          Сравните этот ЖК с&nbsp;другими: жмите плюс&nbsp;— соберём таблицу с&nbsp;выводами в&nbsp;разделе «Сравнение»
        </Body1>

        <Button
          size="XS"
          theme="main_primary"
          type="button"
          onClick={onButtonClick}
          data-testid="NewbuildingCompareFlightOnboardingButton"
        >
          {COMPARE_FLIGHT_ONBOARDING_BUTTON_TEXT}
        </Button>
      </div>
    </div>
  );
}
